import { Component } from '@angular/core';

@Component({
  selector: 'app-error-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './error-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ErrorIconComponent {}
